module.exports = __webpack_public_path__ + "static/media/bg-banner-careers.784c2c1f.jpg";